import { Box } from "@mui/material"
import CustomTable from "../../investorOverview/common/customTable"
import { PrudentialNormsHeaders } from "./tableHeaders"
import { PrudentialNormsBody } from "./tableBodies"
import { AssetClass } from "../../../redux-store/types/api-types"

const prudentialNormsTableData = [
    {
        assetClass: 'Debt',
    },
    {
        assetClass: 'AA (and above)',
        limits: '0-10%',
        actualPortfolio: 10.00,
        flag: true
    },
    {
        assetClass: 'Below AA rated',
        limits: '35-65%',
        actualPortfolio: 80.00,
        flag: false
    },
    // {
    //     assetClass: 'Modified Duration',
    //     limits: '0-10',
    //     actualPortfolio: 10.00,
    //     flag: true
    // },
    // {
    //     assetClass: 'Equity'
    // },
    // {
    //     assetClass: 'Large Cap',
    //     limits: '0-10%',
    //     actualPortfolio: 10.00,
    //     flag: true
    // },
    // {
    //     assetClass: 'Mid Cap',
    //     limits: '35-65%',
    //     actualPortfolio: 70.00,
    //     flag: false
    // },
    // {
    //     assetClass: 'Small Cap',
    //     limits: '0-20%',
    //     actualPortfolio: 20.00,
    //     flag: true
    // },
]

export default function PrudentialNormsTable(): JSX.Element {
    return (
        <Box>
            <CustomTable
                loadingRowsNum={5}
                isLoading={false}
                tableBody={
                    <PrudentialNormsBody
                        tableBodyData={prudentialNormsTableData || []}
                    />
                }
                tableData={prudentialNormsTableData || []}
                tableBodyLoaderRowCustomStyles={{
                    '& td:first-of-type': {
                        paddingLeft: "0px"
                    },
                }}
                tableHeaderData={PrudentialNormsHeaders}
                tableHeadRowCustomStyles={{
                    '& th:first-of-type': {
                        paddingLeft: "0px",
                    }
                }}
                handleSort={() => { console.log("SORT") }}
                tableBodyCustomStyles={{
                    '& tr:last-child td': {
                        border: 0
                    }
                }}
                // order={sortingObj.order}
                // orderBy={sortingObj.orderBy}
                tableDataCount={prudentialNormsTableData?.length || 0}
                isPaginationVisible={false}
            />
        </Box>
    )
}